import { call, put, takeEvery } from "redux-saga/effects";
import { loginRequest, loginSuccess, loginFailure } from "../slice/authSlice";
import { loginApi } from "../../api/apiService";
import { iframeMessaging } from "@src/utils/iframeMessaging";

function* login(action: { payload: { email: string; password: string } }): Generator<any, void, any> {
    try {
        // Call the login API
        const response = yield call(loginApi, action.payload);

        // Extract access and refresh tokens from the response
        const { access, refresh } = response.data;
        // Send tokens to parent window if needed (real user only)
        iframeMessaging.sendTokenToParentIfNeeded({ accessToken: access, refreshToken: refresh }, action.payload.email);

        // Dispatch success action with tokens
        yield put(loginSuccess({ accessToken: access, refreshToken: refresh }));
    } catch (error: unknown) {
        if (error instanceof Error) {
            if ((error as any).response && (error as any).response.data) {
                yield put(loginFailure((error as any).response.data.detail));
            } else {
                yield put(loginFailure("An unknown error occurred."));
            }
        } else {
            yield put(loginFailure("An unknown error occurred."));
        }
    }
}

export function* authSaga() {
    yield takeEvery(loginRequest, login);
}
